import { render, staticRenderFns } from "./bottomToolbar.vue?vue&type=template&id=6a84b91e&"
import script from "./bottomToolbar.vue?vue&type=script&lang=js&"
export * from "./bottomToolbar.vue?vue&type=script&lang=js&"
import style0 from "./bottomToolbar.vue?vue&type=style&index=0&id=6a84b91e&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a84b91e')) {
      api.createRecord('6a84b91e', component.options)
    } else {
      api.reload('6a84b91e', component.options)
    }
    module.hot.accept("./bottomToolbar.vue?vue&type=template&id=6a84b91e&", function () {
      api.rerender('6a84b91e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bottomToolbar/bottomToolbar.vue"
export default component.exports